import {Controller} from "stimulus"

export default class extends Controller {
  connect() {
    this.canShare = typeof navigator.share !== 'undefined'

    if (!this.canShare) {
      console.warn('Web Share API is not supported in this browser')

      this.element.classList.add('d-none')
    } else {
      this.element.classList.remove('d-none')
    }
  }

  share(event) {
    event.preventDefault()

    if (!this.canShare) {
      console.warn('Web Share API is not supported in this browser')
      return
    }

    const shareData = {}

    const title = this.data.get('title')
    const text = this.data.get('text')
    const url = this.data.get('url')

    if (title) {
      shareData.title = title
    }

    if (text) {
      shareData.text = text
    }

    if (url) {
      shareData.url = url
    }

    if (Object.keys(shareData).length === 0) {
      console.warn('No data to share')
      return
    }

    navigator.share(shareData)
      .then(() => {
        console.log('Content shared successfully')
        this.element.dispatchEvent(new CustomEvent('success'))
      })
      .catch((error) => {
        console.error('Error sharing content:', error)
        this.element.dispatchEvent(new CustomEvent('error', {detail: {error}}))

        // Alert user in a more visible way
        if (error.name === 'AbortError') {
          console.log('User canceled the share operation')
        } else {
          console.error('Share failed:', error.message)
        }
      })
  }
}
